import React, { Component } from 'react'
import { Form } from 'react-bootstrap';
import Validator from 'validatorjs';
import * as _ from 'lodash';

import { FormControl } from '../../../../facturotopia';
import { UsoDeCfdiCatalog } from '../../../../support/catalogs/UsoCfdiCatalog';

class ClienteFiscalInfoForm extends Component {
  state = {};
  usoCfdiCatalog = [];

  constructor(props) {
    super(props);

    this.state = {
      isEmptyDataProp: false,
      validator: new Validator({}, this.rules)
    };
  }

  get rules() {
    return {
      'nombre_comercial': ['required'],
      'razon_social': ['required'],
      'rfc': ['required'],
      'uso_cfdi': ['required'],
    }
  }

  get usoCfdi() {
    const { rfc } = this.props.data;

    const filtered = UsoDeCfdiCatalog.filter((item) => {
      if (!rfc) {
        return false;
      }

      if (rfc.length === 13) {
        return item.fisica === 'Sí';
      }

      return item.moral === 'Sí';
    }).map((item) => {
      return {
        label: `${item.descripcion} (${item.clave})`,
        value: item.clave
      }
    });

    const usoCfdi = _.sortBy(filtered, 'label');

    return [{
      label: 'Selecciona Uso de CFDI',
      value: ''
    }].concat(usoCfdi);
  }

  componentDidMount() {
    const { data } = this.props;

    if (!!data.rfc) {
      this.handleOnChange({});
    } else {
      this.setState({
        isEmptyDataProp: true
      });
    }
  }

  componentDidUpdate() {
    const { isEmptyDataProp } = this.state;
    const { data } = this.props;

    if (isEmptyDataProp && !!data.rfc) {
      this.setState({
        isEmptyDataProp: false
      });

      this.handleOnChange(data);
    }
  }

  validate(data) {
    const validator = new Validator(data, this.rules);

    validator.check();

    this.setState({
      validator
    });

    return validator;
  }

  handleOnChange = (value) => {
    const { step } = this.props;
    const data = {
      ...this.props.data,
      ...value
    }

    const validator = this.validate(data);

    this.props.onFormDataChange({
      data,
      step,
      isValid: validator.passes()
    });
  }

  render() {
    const { data, autoFocus = true } = this.props;
    const { validator } = this.state;

    return (
      <Form autoComplete="off">

        <FormControl type="text"
          label="Nombre comercial"
          name="nombre_comercial"
          placeholder=""
          help=""
          autoFocus={ autoFocus }
          validator={ validator }
          value={ data.nombre_comercial }
          onChange={ this.handleOnChange }
        />

        <FormControl type="text"
          label="Razón social"
          name="razon_social"
          placeholder=""
          help=""
          validator={ validator }
          value={ data.razon_social }
          onChange={ this.handleOnChange }
        />

        <FormControl type="text"
          label="RFC"
          name="rfc"
          placeholder=""
          help=""
          validator={ validator }
          value={ data.rfc }
          onChange={ this.handleOnChange }
        />

        <FormControl type="select"
          label="Uso de CFDI"
          name="uso_cfdi"
          placeholder=""
          help=""
          validator={ validator }
          value={ data.uso_cfdi }
          options={ this.usoCfdi }
          onChange={ this.handleOnChange }
        />

      </Form>
    )
  }
}

export default ClienteFiscalInfoForm;